<!--
  @Description: 专题集合-轮播
  @Author: wang.y 
  @Date: 2022-02-17 
-->
<template>
  <div class="theme-list">
    <Spin fix v-if="$parent.theme_loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <swiper :options="swiper_option" :ref="'swiper' + temp" @slideChange="slideChange">
      <swiper-slide v-for="item,index in data" :key="index">
        <div class="theme-item">
          <div class="collect-icon">
            <i class="iconfont on" title="取消收藏" v-if="item.isCollect" @click.stop="cancelCollect(contentType(item.contentType), item.id, delCollectCb, index), pointCollect()">&#xe66f;</i>
            <i class="iconfont" title="收藏" v-else @click.stop="addCollect(contentType(item.contentType), item.id, addCollectCb, index), pointCollect()">&#xe66f;</i>
          </div>
          <div class="theme-img">
            <img :src="item.coverImgPath | logo_show" @click="goToDetail(item.contentType, item)" />
          </div>
          <div class="theme-item-cnt">
            <div class="title over-p1" @click="goToDetail(item.contentType, item)">{{item.title}}</div>
            <a :href="item.contentType == 2 ? $store.state.index_path + '/specialDetail/' + item.uid : $store.state.index2_path + '/' + item.id"></a>
            <div class="decs over-p3">{{item.summary}}</div>
            <div class="bottom">
              <div class="updata-time">{{item.updateTime | time_standard}}更新</div>
              <div class="release-time">{{item.publishTime | time_standard}}发布</div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div :class="'prev-btn' + ' prev-btn' + temp" v-show="data.length > 3 && current > 0" @click="pointchange()">
      <i class="iconfont">&#xe646;</i>
    </div>
    <div :class="'next-btn' + ' next-btn' + temp" v-show="data.length > 3 && current < data.length - 3" @click="pointchange()">
      <i class="iconfont">&#xe647;</i>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { collect_mixin } from "js/collect_mixin";
export default {
  mixins: [collect_mixin],
  components: {
    swiper, swiperSlide
  },
  created() {
    // this.swiper_option.navigation = {
    //   nextEl: '.next-btn' + this.temp,
    //   prevEl: '.prev-btn' + this.temp
    // }
  },
  mounted() {

  },
  props: ['temp', 'data', 'colType'],
  data() {
    return {
      current: 0,
      swiper_option: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.next-btn' + this.temp,
          prevEl: '.prev-btn' + this.temp
        }
      },
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    contentType() {
      return function (type) {
        return type == '1' ? '4' : type
      }
    }
  },
  methods: {
    pointCollect() {
      if(this.colType == '1'){
        _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(专题/文章的收藏)', '点击量'])
      }
      else if(this.colType == '2'){
        _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(专题/文章的收藏/取消收藏)', '点击量'])
      }
      else if(this.colType == '3'){
        _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(专题/文章的收藏/取消收藏)', '点击量'])
      }
      else if(this.colType == '4'){
        _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(专题/文章的收藏/取消收藏)', '点击量'])
      }
    },
    /**
     * @description: 左右切换埋点
     * @param {*}
     * @return {*}
     */    
    pointchange() {
      if(this.colType == '1'){
        _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(专题/文章的左右切换)', '点击量'])
      }
      else if(this.colType == '2'){
        _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(专题/文章的左右切换)', '点击量'])
      }
      else if(this.colType == '3'){
        _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(专题/文章的左右切换)', '点击量'])
      }
      else if(this.colType == '4'){
        _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(专题/文章的左右切换)', '点击量'])
      }
    },
    slideChange() {
      this.current = this.$refs['swiper' + this.temp].swiper.activeIndex
      console.log(this.current)
    },
    addCollectCb(index) {
      this.data[index].isCollect = true
    },
    delCollectCb(index) {
      this.data[index].isCollect = false
    },
    goToDetail(type, item) {
      if (type == 2) {
        const { href } = this.$router.resolve({ name: "SpecialDetail", params: { uid: item.uid } })
        window.open(href, '_blank')
      } else {
        const temp_href = this.$store.state.index2_path + '/' + item.id
        window.open(temp_href, '_blank')
      }
      if(this.colType == '1'){
        _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(专题/文章的标题)', '点击量'])
      }
      else if(this.colType == '2'){
        _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(专题/文章的标题)', '点击量'])
      }
      else if(this.colType == '3'){
        _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(专题/文章的标题)', '点击量'])
      }
      else if(this.colType == '4'){
        _czc.push(['_trackEvent', '找公司(新)', '科技巨头投资版图(专题/文章的标题)', '点击量'])
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
.theme-list
  position relative
  min-height 298px
  .swiper-container
    width 730px
    padding-bottom 18px
    .swiper-slide
      width 230px
  .prev-btn, .next-btn
    position absolute
    width 40px
    height 40px
    background rgba(255, 136, 36, 0.6)
    display flex
    align-items center
    justify-content center
    z-index 2
    left -10px
    top 114px
    cursor pointer
    .iconfont
      color #fff
      font-size 28px
  .next-btn
    left auto
    right -10px
  .theme-item
    box-shadow 0px 5px 10px 0px rgba(121, 133, 143, 0.2)
    position relative
    .collect-icon
      position absolute
      z-index 4
      right 10px
      top 10px
      width 16px
      height 16px
      background #F3F3F3
      border-radius 4px
      display flex
      justify-content center
      align-items center
      margin 2px 0 0 12px
      cursor pointer
      .iconfont
        font-size 12px
        color #CCCCCC
        &.on
          color #FF8824
    .theme-img
      width 230px
      height 144px
      cursor pointer
      overflow hidden
      img
        width 100%
        height 100%
        display block
        transition all 0.5s
        &:hover
          transform scale(1.1)
    &-cnt
      position relative
      background #fff
      padding 12px
      height 154px
      .title
        font-size 16px
        color #333333
        line-height 1
        cursor pointer
        transition all .5s
        &:hover
          color #FF8824
      .decs
        margin-top 10px
        font-size 13px
        color #666666
        line-height 20px
      .bottom
        position absolute
        left 0
        bottom 16px
        display flex
        justify-content space-between
        width 100%
        padding 0 12px
        .updata-time
          padding 0 10px
          height 22px
          display flex
          align-items center
          background #FFF4EA
          border-radius 11px
          font-size 12px
          color #FF8824
          cursor pointer
        .release-time
          font-size 12px
          color #CCCCCC
          line-height 22px
</style>